import { log } from '@atlassian/jira-common-util-logging';
import { fireErrorAnalytics, safeStringify } from '@atlassian/jira-errors-handling';
import type { LogMessage, LogApolloErrorMessage } from './types';

export const logErrorAndFireAnalytics = (errorMessage: LogMessage) => {
	const { packageName, locationId, message, error } = errorMessage;

	log.safeErrorWithoutCustomerData(`${packageName}.${locationId}`, message, error);

	fireErrorAnalytics({
		meta: {
			id: locationId,
			packageName,
		},
		error,
		sendToPrivacyUnsafeSplunk: true,
	});
};

// @ts-expect-error - TS7031 - Binding element 'graphQLErrors' implicitly has an 'any' type. | TS7031 - Binding element 'networkError' implicitly has an 'any' type.
const transformErrorMessages = ({ graphQLErrors, networkError }) => {
	const errorMessages: Array<string> = [];
	if (graphQLErrors)
		// @ts-expect-error - TS7031 - Binding element 'message' implicitly has an 'any' type. | TS7031 - Binding element 'locations' implicitly has an 'any' type. | TS7031 - Binding element 'path' implicitly has an 'any' type.
		graphQLErrors.forEach(({ message, locations, path }) => {
			errorMessages.push(
				`[GraphQL error]: Message: ${safeStringify(message)}, Location: ${safeStringify(
					locations,
				)}, Path: ${safeStringify(path)}`,
			);
		});

	if (networkError) {
		errorMessages.push(`[Network error]: ${safeStringify(networkError)}`);
	}
	return errorMessages;
};

export const logApolloErrorAndFireAnalytics = (errorMessage: LogApolloErrorMessage) => {
	const { error, message } = errorMessage;
	const joinedMessage = `${message}: [Top level message]: ${
		error.message
	}:\n ${transformErrorMessages(error).join('\n')}`;
	logErrorAndFireAnalytics({
		...errorMessage,
		error: new Error(joinedMessage),
	});
};
